export default __webpack_public_path__ + "static/media/defender-circle.870acb33.svg";